import React from 'react'

import { IResourceHub as IContentfulResourceHub } from 'marketing-site/@types/generated/contentful'
import { useLearnDirectory } from 'marketing-site/src/components/context/LearnDirectoryContext'
import { ResourceHub } from 'marketing-site/src/components/bespoke/resources/hub'

export const ContentfulResourceHub = (resourceHub: IContentfulResourceHub) => {
  const learnDirectory = useLearnDirectory()

  return <ResourceHub resourceHub={resourceHub.fields} learnDirectory={learnDirectory} />
}
